@if (should_show_header) {
    <div class="section-header">
        {{ appStringAPI.getAppString('tennis.players.section.social') }}
    </div>
}

@if (feedItems.length) {
    <section class="social-feed-carousel">
        <div class="feed-details-container">
            <div class="feed-details">
                <app-image [image_url]="social_feed.profile_icon" width="42px" height="42px" border_radius="50%" margin="0.1rem" style="width: auto"></app-image>
                <span> {{ social_feed.name }} </span>
            </div>
            <!-- @if (social_feed) {
                <div>see all</div>
            } -->
        </div>

        <app-carousel [config]="splideConfig">
            @for (item of feedItems; track $index) {
                <app-slide (click)="openLink(item.link)">
                    @if (isImage(item)) {
                        <article [style.backgroundImage]="handleBackground(item.media_content)" [style.aspectRatio]="'1/1'">
                            <footer class="media-description">
                                <div class="account-info">
                                    <!-- <app-image [image_url]="profileImage(item)" width="42px" height="42px" border_radius="50%" margin="0.5rem"></app-image>
                                    <span> {{ item.user_full_name }} </span> -->
                                </div>
                                <div class="post-content" [innerHTML]="parseDesc(item.description, feedType)"></div>
                            </footer>
                            @if (isYoutubeVideo(item)) {
                                <img src="/assets/play_button.png" />
                            }
                        </article>
                    } @else if (!isImage(item)) {
                        <article [style.aspectRatio]="'1/1'">
                            <video [src]="item.media_content"></video>
                            <footer class="media-description no-media-description" style="z-index: 1">
                                <div class="account-info">
                                    <!-- <app-image [image_url]="profileImage(item)" width="42px" height="42px" border_radius="50%" margin="0.5rem"></app-image>
                                    <span> {{ item.user_full_name }} </span> -->
                                </div>
                                <div class="post-content" [innerHTML]="parseDesc(item.description, feedType)" [class]="!hasChild(item) ? 'no-media-content' : ''"></div>
                                @if (hasChild(item)) {
                                    <div class="quote-tweets">
                                        <!-- <div class="account-info">
                                            <app-image [image_url]="profileImage(item.child_feed_item)" width="22px" height="22px" border_radius="50%" margin="0.1rem"></app-image>
                                            <span> {{ item.child_feed_item.user_full_name }} </span>
                                        </div> -->
                                        <div class="quote-content">{{ item.child_feed_item.description }}</div>
                                    </div>
                                }

                                <div class="feed-date">{{ item.publication_date | date: 'shortTime' }} - {{ item.publication_date | date: 'mediumDate' }}</div>
                            </footer>
                            @if (isYoutubeVideo(item)) {
                                <img class="video-button-img" src="/assets/play_button.png" />
                            }
                        </article>
                    }
                </app-slide>
            }
        </app-carousel>
    </section>
}
